import React, { useEffect, useState } from 'react';
import {  Col, Container, Row } from 'react-bootstrap';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PageSummary_SearchRequest } from '../../Models/Model';
import { ContainerType, PageType } from '../../Models/Enum';
import { SimpleResponse } from '../../Models/ResponseModel';
import pageService from '../../Services/pageService';
import FruitCard from '../../Components/FruitCard';
import PackagingComponent from '../../Components/PackagingComponent';
import VideoComponent from '../../Components/VideoComponent';
import FruitTrail from '../../Components/FruitTrail';
import FarmerTestimonialsComponent from '../../Components/FarmerTestimonialsComponent';
import IconComponent from '../../Components/IconComponent';
import { IMAGE_MAIN_ENDPOINT } from '../../constant';
import test from '../../../server-build/Images/HeaderCategorytest.png';
import { FruitCardresponsive } from '../../Helpers/Responsive';
import Carousel from "react-multi-carousel";








function FruitCategory(props) {

    const [pageData, setPageData] = useState();
    const [Cards, setCards] = useState([]);

    var parsedDATA = props.data.ContentJson;
    console.log("parsedData", parsedDATA);
    var packagingCardHeading = " Variety of packaging to  choose from";
    var farmerCardHeading = "Hear from our farmer";
    var farmerCardSubheading = "   We believe in growing together.  Read these testimonials and taste the difference genuine care makes in every fruit we bring you."


    useEffect(() => {
        getCardData();
    }, [props.data.PageID]);

    const getCardData = async () => {

        let req = new PageSummary_SearchRequest();
        req.PageTypeID = PageType.FruitDetail;
        req.ParentPageID = props.data.PageID;

        try {
            let resp: SimpleResponse = await pageService.getInstance().PageSummary_Search(req);
            if (resp.HasError) {
                return;
            }
            setCards(resp.Result);
        } catch (e) {

        }
    }



    return (
        <div className='container-fluid'>

            <div className='row categoryBg' >
                <div className='col'>
                    <div className="row mb-5">

                        <div className='col p-0'>
                            <img className='img-fluid w-100 ' src={IMAGE_MAIN_ENDPOINT + (parsedDATA.FLD_0_3_7_7 != undefined && parsedDATA.FLD_0_3_7_7 != null && parsedDATA.FLD_0_3_7_7)} />
                        </div>
                    </div>
                    <Container className='mb-5'>
                        <div className='row'>
                            <div className='col'>
                                <h1 className='text-center '>{parsedDATA.FLD_0_1_40_40} </h1>

                                <div dangerouslySetInnerHTML={{ __html: parsedDATA.FLD_0_10_44_44 }} />
                            </div>
                        </div>
                    </Container>

                </div>
            </div>

            {/* <div className='row categoryBg'>
                <div className='col'>
                    <Carousel>
                        <Carousel.Item>
                        <img className='img-fluid w-100 '  src="../../../server-build/Images/HeaderCategorytest.png" />
                            <Carousel.Caption  className="d-flex flex-column text-dark justify-content-center h-100 pt-0 pb-0 " style={{top:'0px', bottom:'0px'}} >
                            <h1 className='text-center '>Premium Indian Mangoes </h1>
                                <p className='text-center '>With so many mango varieties grown across India, from the sweet Alphonso of Ratnagiri and the zesty Kesar of<br />
                                    Gujarat to the tangy Dussheri of Uttar Pradesh, each mango offers a unique taste adventure. It's not just a fruit;<br />
                                    it's a celebration of India's agricultural richness.</p>
                            </Carousel.Caption>
                        </Carousel.Item>
                    </Carousel>
                </div>
            </div> */}



            <div className='row'>
                <div className='col'>
                    <IconComponent data={props} />
                </div>
            </div>



            <div className='row mb-5 pb-0 pb-lg-5'>
                <div className='col'>
                    <div className='row'>
                        <div className='col'>
                            <div className='container'>
                                <div className='row mb-4'>
                                    <div className='col text-center'>
                                        <h2>{parsedDATA.FLD_0_1_43_43}</h2>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <Container>
                                <Row xs={1} md={2} lg={3} xl={4} className="fruitCardList justify-content-center justify-content-lg-start d-none d-lg-flex" >
                                    {Cards.length > 0 && Cards.map((item, index) => (
                                        <Col key={index} className='ps-2 pe-2 listCard '>
                                            <FruitCard item={item} />

                                        </Col>
                                    ))}
                                </Row>

                                <div className="row CardCarousel d-lg-none">
                                    <div className="col">
                                        <Carousel responsive={FruitCardresponsive} ssr swipeable={true} draggable={true} >
                                            {Cards != undefined && Cards.length > 0 && Cards.map((item, index) => (
                                                <div key={index} className='ps-2 pe-2 mb-2 ' >
                                                    <FruitCard item={item} />
                                                </div>
                                            ))}
                                        </Carousel>
                                    </div>
                                </div>
                                
                                <div className='row mt-2 mt-lg-0'>
                                    <div className='col'>
                                        <a href='/Products' target='_blank' style={{ color: 'black' }}><p className='d-flex fruitCardList align-items-center justify-content-center justify-content-md-start ms-0 ms-md-4 ms-lg-0 '><FontAwesomeIcon icon={faChevronLeft} /> &nbsp;&nbsp;<span className='text-decoration-underline fw-bold'>View All Fruits</span> </p></a>
                                    </div>
                                </div>
                            </Container>
                        </div>
                    </div>

                    {/* <div className="row mb-5 pb-0 pb-lg-5 ">
                        <div className="col">
                            <Container>
                                <div className="row">
                                    <div className="col">
                                        <Carousel responsive={FruitCardresponsive} ssr >
                                            {Cards != undefined && Cards.length > 0 && Cards.map((item, index) => (
                                                <div key={index} className='ps-2 pe-2 mb-2' >
                                                    <FruitCard item={item} />
                                                </div>
                                            ))}
                                        </Carousel>
                                    </div>
                                </div>
                            </Container>

                        </div>
                    </div> */}

                </div>
            </div>


            {/* <div className='row mb-5'>
                    <div className='col-lg-1 offset-lg-3 col-12'>
                        <h3 className='fw-bold'>Variety of <br /> packaging to <br />
                            choose from</h3>
                        <div>
                            <FontAwesomeIcon icon={faArrowLeft} className='pe-3 fa-xl' /> &nbsp; &nbsp;
                            <FontAwesomeIcon icon={faArrowRight} className=' fa-xl' />
                        </div>
                    </div>

                    <div className='col-lg-8 col-12'>
                        <Carousel responsive={responsive} ssr >
                            {parsedDATA.FLD_0_4_15_15 != null && parsedDATA.FLD_0_4_15_15.length>0 && parsedDATA.FLD_0_4_15_15.map((items, index) => (
                                <div key={index} className='ps-2 pe-2'>
                                    <Testimonials items={items} />
                                </div>
                            ))}
                        </Carousel>
                    </div>

                </div> */}

            <div className='row mb-5 pb-0 pb-lg-5  packagingCategory' >
                <div className='col '>
                    <PackagingComponent data={props.data.ContentJson.FLD_0_4_15_15} Heading={packagingCardHeading} />
                </div>
            </div>

            <div className='row mb-5 pb-0 pb-lg-5'>
                <div className='col'>
                    <Container >
                        <div className='row justify-content-center align-items-center'>
                            <div className='col-auto'>
                                <h1 className='text-center mb-4 '>{parsedDATA.FLD_0_1_46_46}</h1>
                                <img className='img-fluid ' src={IMAGE_MAIN_ENDPOINT + (parsedDATA.FLD_0_3_9_9 != undefined && parsedDATA.FLD_0_3_9_9 != null && parsedDATA.FLD_0_3_9_9)} />
                            </div>
                        </div>
                    </Container>
                </div>
            </div>



            <div className="row "  >
                <div className="col">
                    <img className="img-fluid scrollImage " src='../server-build/Images/ScrollingText11.png' />

                </div>
            </div>

            <div className='row mb-5 pb-0 pb-lg-5'>
                <div className='col'>

                    <VideoComponent data={props} />
                </div>
            </div>


            {/* <div className='row mb-5'>
                    <div className='col'>
                        <div className='row position-relative mangoTrail' style={{ height: '668px', backgroundColor: '#3a785d',  backgroundImage: `url('../../../server-build/Images/MapBackgroung1.png')`}}  >
                            <div className='col'>
                                <h1 className='text-center mt-5 text-white'>The Superplum Mango Trail</h1>
                            </div>
                            <Container className='position-absolute' style={{ top: '170px' }}>
                                <div className='row justify-content-center align-items-center'>
                                    <div className='col-auto'>
                                        <img
                                            className='img-fluid'
                                            src={IMAGE_MAIN_ENDPOINT+ (parsedDATA.FLD_0_3_47_47 != undefined && parsedDATA.FLD_0_3_47_47 != null && parsedDATA.FLD_0_3_47_47)}
                                            alt='Mango Trail'
                                        />
                                    </div>
                                </div>
                            </Container>
                        </div>
                    </div>
                </div> */}

            <div className='row mb-5 pb-0 pb-lg-5'>
                <div className='col'>
                    <FruitTrail data={props} />
                </div>
            </div>

            <div className='row mb-5 pb-0 pb-lg-5 farmerCard'>
                <div className='col'>
                    <FarmerTestimonialsComponent data={props.data.ContentJson.FLD_1_9_11_11} Heading={farmerCardHeading} SubHeading={farmerCardSubheading} />

                </div>
            </div>




            {/* <div className='row mb-5 pb-5'>
                    {/* <div className='col-1 offset-lg-3'>
                        <Card style={{ width: '18rem', border: 0 }} className='farmerTestimonialsHeading' >
                            <Card.Body>
                                <div className='h1'>Hear from
                                    our farmers</div>
                                <Card.Text className='fw-bold'>
                                    We believe in growing together.
                                    Read these testimonials and taste
                                    the difference genuine care makes
                                    in every fruit we bring you.
                                </Card.Text>
                                <div className='d-flex justify-content-around'>
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </div>
                            </Card.Body>
                        </Card>    
                    </div> */}
            {/* <div className='col-lg-2 offset-xl-3 col-12'>
                        <h2 className='fw-bold'> Hear from <br/>
                            our farmers</h2>
                        <p className='fw-bold mb-5'>
                            We believe in growing together.<br/>
                            Read these testimonials and taste<br/>
                            the difference genuine care makes<br/>
                            in every fruit we bring you.
                        </p>
                        <div className='d-flex justify-content-evenly'>
                            <FontAwesomeIcon icon={faArrowLeft} className='fa-xl' />
                            <FontAwesomeIcon icon={faArrowRight} className='fa-xl' />
                        </div>
                    </div>


                    <div className='col-6'>
                        <Carousel responsive={responsive} ssr  >
                            {parsedDATA.FLD_1_11 != undefined && parsedDATA.FLD_1_11.length>0 && parsedDATA.FLD_1_11.map((item, index) => (
                                <div key={index} className='ps-2 pe-2'>
                                    <TextTestimonials item={item} />

                                </div>
                            ))}
                        </Carousel>
                    </div>
                </div>  */}

        </div>
    );


}

export default FruitCategory; 